<script>
import truncate from 'truncate';

export default {
    props: {
        labels: String,
        titles: String,
        showNationalityFilter: Boolean,
        hideSubcategoryFilter: Boolean,
        nationalityFilter: String,
        subtitles: String,
        contactGroup: String,
        years: String,
        lang: String,
    },
    computed: {
        getTitleFilter() {
            const title = this.parsedTitles.find((item) => item.term_id == this.filterParams.contact_title);
            return title ? title.name : null;
        },
        getSubtitleFilter() {
            const subtitle = Object.entries(this.parsedSubtitles).find(pair => pair[1] === this.chosenSubtitle);
            return subtitle ? subtitle[0] : null;
        },
        getNationalityFilter() {
            return this.parsedNationalityFilter[this.filterParams.nationality_id] ?? null;
        },
    },
    mounted() {
        this.parsedLabels = JSON.parse(this.labels);
        this.parsedTitles = JSON.parse(this.titles);
        this.parsedSubtitles = JSON.parse(this.subtitles);
        this.parsedNationalityFilter = JSON.parse(this.nationalityFilter);
        this.filterParams.lang = this.lang;

        const urlParams = new URLSearchParams(window.location.search);
        let contacts = [...window.cached_contacts.contacts];

        if (urlParams.has('c')) {
            this.showFilter = true;
            const c = urlParams.get('c');
            this.filterParams.contact_title = c;
        }

        if (urlParams.has('sc')) {
            this.showFilter = true;
            const sc = urlParams.get('sc');
            this.chosenSubtitle = sc;
        }

        contacts = contacts.filter(contact =>
            contact.contact_group.some(group => group.term_id ==
                this.contactGroup)
        );

        this.contacts = contacts;

        //const sortedContacts = this.contacts.reduce((acc, contact) => {
        //    const firstLetter = contact.last_name[0].toUpperCase();
        //
        //    if (!acc[firstLetter]) {
        //        acc[firstLetter] = [];
        //    }
        //
        //    acc[firstLetter].push(contact);
        //
        //    return acc;
        //}, {});

        this.sortedContacts = this.getSortedContacts(contacts);
    },
    data() {
        return {
            filterParams: {
                order: 'asc',
                orderby: 'title',
                per_page: 999,
                page: 1,
                search: '',
                contact_title: '',
                contact_group: '',
                nationality_id: '',
                lang: ''
            },
            chosenSubtitle: '',
            chosenNationality: '',
            pageCount: 1,
            showFilter: false,
            parsedLabels: [],
            parsedTitles: [],
            parsedSubtitles: [],
            parsedNationalityFilter: [],
            loading: false,
            contacts: [],
            sortedContacts: [],
        };
    },
    watch: {
        chosenSubtitle(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getPosts();
            }
        },
        'filterParams.contact_title'(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getPosts();
            }
        },
        'filterParams.nationality_id'(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getPosts();
            }
        },
    },
    methods: {
        getPosts() {
            let params = Object.assign({}, this.filterParams);
            let contacts = [...window.cached_contacts.contacts];

            contacts = contacts.filter(contact =>
                contact.contact_group.some(group => group.term_id ==
                    this.contactGroup)
            );

            if (params.search) {
                const searchTerm = params.search.toLowerCase();

                contacts = contacts.filter(contact =>
                    contact.title && contact.title.toLowerCase().includes(searchTerm)
                );
            }

            if (params.nationality_id !== '') {
                contacts = contacts.filter(contact =>
                    contact.nationality == params.nationality_id
                );
            }

            if (params.contact_title) {
                contacts = contacts.filter(contact =>
                    contact.titles.some(title => title.term_id ==
                        params.contact_title)
                );
            }

            if (this.chosenSubtitle) {
                const subtitleIds = this.chosenSubtitle.split(',');
                contacts = contacts.filter(contact => {
                    if (Array.isArray(subtitleIds)) {
                        return contact.titles.some(title =>
                            subtitleIds.includes(title.term_id.toString())
                        );
                    }
                });
            }

            this.contacts = contacts;
            this.sortedContacts = this.getSortedContacts(contacts);
        },
        getSortedContacts(contacts) {
            return contacts.reduce((acc, contact) => {
                const firstLetter = contact.last_name[0].toUpperCase();

                if (!acc[firstLetter]) {
                    acc[firstLetter] = [];
                }

                acc[firstLetter].push(contact);

                return acc;
            }, {});
        },
        truncateString(string, limit) {
            return truncate(string, limit);
        },
        formSubmit(e) {
            e.preventDefault();
            this.getPosts();
        },
        resetTitleFilter() {
            this.filterParams.contact_title = '';
        },
        resetSubtitleFilter() {
            this.chosenSubtitle = '';
        },
        resetNationalityFilter() {
            this.filterParams.nationality_id = '';
        },
        getTitles(item) {
            if (!item.titles) {
                return;
            }

            let titles = '';
            const parsedTitlesIds = this.parsedTitles.map(item => item.term_id);
            const relevantTitles = item.titles.filter(title => parsedTitlesIds.includes(title.term_id));

            relevantTitles.map((title) => {
                titles += '<div class="contacts__item-tags">';
                title.children.map((child) => {
                    titles += `<span class="contacts__item-tag">${child.name}</span>`;
                });
                titles += `<span class="contacts__item-tag">${title.name}</span>`;
                titles += '</div>';
            });

            return titles;
        },
        updateUrlParams() {
            const urlParams = new URLSearchParams(window.location.search);

            if (this.filterParams.hasOwnProperty('contact_title')) {
                if (this.filterParams.contact_title !== '') {
                    urlParams.set('c', this.filterParams.contact_title);
                } else {
                    urlParams.delete('c');
                }
            }

            if (this.chosenSubtitle !== '') {
                urlParams.set('sc', this.chosenSubtitle);
            } else {
                urlParams.delete('sc');
            }

            window.history.pushState('', '', '?' + urlParams.toString());
        }
    },
};
</script>

<template>
    <form class="form" @submit="formSubmit">
        <fieldset>
            <input class="form__field" type="text" v-model="filterParams.search" :aria-label="parsedLabels.search_label" />
            <button type="submit" class="button button--search" :aria-label="parsedLabels.search_button"></button>
            <button type="button" class="button button--filter" @click="showFilter = !showFilter">{{
                    parsedLabels.filter_button
            }}</button>
        </fieldset>
        <fieldset v-if="showFilter">
            <select class="form__select" v-model="filterParams.contact_title">
                <option value disabled selected hidden>{{ parsedLabels.category_placeholder }}</option>
                <option v-for="item in parsedTitles" :value="item.term_id" :key="item.slug">{{ item.name }}</option>
            </select>
            <select class="form__select" v-if="!showNationalityFilter && (Object.keys(parsedSubtitles).length > 0 && !hideSubcategoryFilter)" v-model="chosenSubtitle">
                <option value disabled selected hidden>{{ parsedLabels.subcategory_placeholder }}</option>
                <option v-for="(value, key) in parsedSubtitles" :value="value" :key="key">{{ key }}</option>
            </select>
        </fieldset>
        <fieldset v-if="showFilter && showNationalityFilter">
            <select class="form__select" v-if="Object.keys(parsedSubtitles).length > 0 && !hideSubcategoryFilter" v-model="chosenSubtitle">
                <option value disabled selected hidden>{{ parsedLabels.subcategory_placeholder }}</option>
                <option v-for="(value, key) in parsedSubtitles" :value="value" :key="key">{{ key }}</option>
            </select>
            <select class="form__select" v-model="filterParams.nationality_id">
                <option value disabled selected hidden>{{ parsedLabels.nationality_placeholder }}</option>
                <option v-for="(value, key) in parsedNationalityFilter" :value="key" :key="key">{{ value }}</option>
            </select>
        </fieldset>
    </form>
    <div class="contacts">
        <div class="active-filters">
            <strong v-if="getTitleFilter || getSubtitleFilter || getNationalityFilter">{{ parsedLabels.filter_label }}:</strong>
            <button class="active-filters__button" @click="resetTitleFilter()">{{ getTitleFilter }}</button>
            <button class="active-filters__button" @click="resetSubtitleFilter()">{{ getSubtitleFilter }}</button>
            <button class="active-filters__button" @click="resetNationalityFilter()">{{ getNationalityFilter }}</button>
        </div>
        <div v-if="loading" class="contacts__loader">
            <div class="loader"></div>
        </div>
        <div>
            <div v-for="(contacts, letter) in sortedContacts" :key="letter">
                <h2 class="contacts__letter">{{ letter }}</h2>
                <ul class="contacts__list">
                    <li class="contacts__item" v-for="item in contacts" :key="item.id">
                        <h3 class="contacts__item-title">
                            <a class="contacts__item-link" :href="item.link" v-html=item.title></a>
                        </h3>
                        <p class="contacts__item-position" v-if="item.position">{{ item.position }}</p>
                        <div v-if="item.titles" v-html="getTitles(item)"></div>
                    </li>
                </ul>
            </div>
            <p v-if="contacts.length === 0">{{ parsedLabels.no_result }}</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.form {
    @include wrap(content);
    margin-bottom: 32px;

    @include media(M) {
        margin-bottom: 64px;
    }

    fieldset {
        max-width: map-get($maxwidths, 'content');
        display: flex;
        gap: 8px;
        margin-bottom: 8px;
    }

    input[type='text'] {
        width: 100%;
    }
}
</style>
